"use strict";

import Vue from 'vue';

let framesPool = [];

function createNewFrame() {
    let frame = document.createElement('iframe');
    framesPool.push(frame);
    frame.lastUse = Date.now();
    frame.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;visibility:hidden;';
    frame.frameBorder = '0';
    document.body.appendChild(frame);
    return frame;
}

function callWithScheme(url) {
    let frame;
    for (let i = 0, len = framesPool.length; i < len; i++) {
        if (Date.now() - framesPool[i].lastUse > 1000) {
            frame = framesPool[i];
            frame.lastUse = Date.now();
            break;
        }
    }
    (frame || createNewFrame()).src = url;
}

let seq = 1;
let map = {};

/*
  jsbridge.call('getToken', {router: 'homepage'}, function(res) {
      that.token = res.repair;
  }, this);
*/
let jsbridge = {//2种方法，app支持哪种就用哪种
    //使用路由委托navigationDelegate拦截url
    call: function (name, args, cb) {
        if(navigator.userAgent.indexOf(' demeter/') != -1) {//webview_flutter加载的webview
            this.post(name, args, cb);
            return;
        }
        if(navigator.userAgent.indexOf('_demeter/') == -1) {
            return;
        }
		let url = 'jsToFlutter://postMessage?value='+encodeURIComponent(JSON.stringify({
            action: name,
            data: args,
            seqid: seq,
            callback: 'kappback'
        }));
		map[seq++] = {
            cb: cb || (args||{})['callback']
		};
		callWithScheme(url);
	},
    //使用javascriptChannels发送消息
    post: function (name, args, cb) {
        if(navigator.userAgent.indexOf('_demeter/') != -1) {//flutter_webview_plugin加载的native_webview
            this.call(name, args, cb);
            return;
        }
        if(navigator.userAgent.indexOf('demeter/') == -1) {
            return;
        }
        if(window[name]) {
            map[seq] = {
                cb: cb || (args||{})['callback']
            };
            window[name].postMessage(JSON.stringify({
                action: name,
                data: args,
                seqid: seq,
                callback: 'kappback'
            }));
            ++seq;
        }
    },
    //inappwebview的JavaScriptHandler
    handler: function (name, args, cb) {
        let params = {
            action: name,
            data: args,
            seqid: seq,
            callback: 'kappback'
        };
        //app的按钮点击触发,比如设置右上角查看历史
        let callback = (args||{})['callback']; 
        if (callback) {
            map[seq] = {
                cb: callback
            };
        }
        seq++;
        if(window.flutter_inappwebview) {
            if (!cb) {
                window.flutter_inappwebview.callHandler(name, params);
            } else {
                window.flutter_inappwebview.callHandler(name, params).then(result => {
                    cb(result);
                });
            }
        }
    }
};

window.kappback = function (res) {
    if (map[res.seqid]) {
        map[res.seqid].cb && map[res.seqid].cb(res);
        if(!res.listener) {
            delete map[res.seqid];
        }
    }
};

const Plugin = {
    install: function (Vue) {
        Vue.$jsbridge = jsbridge;
        window.$jsbridge = jsbridge;
        Object.defineProperty(Vue.prototype, '$jsbridge', {
            value: jsbridge
        });
    }
};

Vue.use(Plugin);

export default jsbridge;
